import frontCover2 from "./photos/FrontCover2.jpg"
import album from "./photos/Album.jpg"
import show1 from "./photos/show1.jpg"
import show2 from "./photos/show2.jpg"
import shoot1 from "./photos/shoot1.jpg"
import shoot2 from "./photos/shoot2.jpg"
import shoot3 from "./photos/shoot3.jpg"
import shoot4 from "./photos/shoot4.jpg"
import shoot5 from "./photos/shoot5.jpg"
import show3 from "./photos/show3.jpg"
import show4 from "./photos/show4.jpg"
import show5 from "./photos/show5.jpg"
import show6 from "./photos/show6.jpg"
import show7 from "./photos/show7.jpg"

export const photoPageData = [
    {
        img: show1,
        type: "live"
    },
    {
        img: show2,
        type: "live"
    },
    {
        img: shoot1,
        type: "other"
    },
    {
        img: shoot2,
        type: "other"
    },
    {
        img: shoot3,
        type: "other"
    },
    {
        img: frontCover2,
        type: "artwork"
    },
    {
        img: shoot4,
        type: "other"
    },
    {
        img: shoot5,
        type: "other"
    },
    {
        img: show3,
        type: "live"
    },
    {
        img: album,
        type: "artwork"
    },
    {
        img: show4,
        type: "live"
    },
    {
        img: show5,
        type: "live"
    },
    {
        img: show6,
        type: "live"
    },
    {
        img: show7,
        type: "live"
    },
]